export const useReviews = () => {
    const reviewsCache = ref(new Map())
  
    const fetchRatingReview = async (productId, handle) => {
      // Check if data exists in cache
      const cacheKey = `${productId}-${handle}`
      if (reviewsCache.value.has(cacheKey)) {
        return reviewsCache.value.get(cacheKey)
      }
  
      try {
        const data = await $fetch(
          `/api/fetchReviewsCount?product_id=${productId}&handle=${handle}`
        )
        
        // Store in cache
        reviewsCache.value.set(cacheKey, data)
        
        return data
      } catch (err) {
        console.error(err.message || 'An error occurred while fetching reviews.')
        return null
      }
    }
  
    return {
      fetchRatingReview,
      reviewsCache
    }
  }